import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  token: localStorage.access_token ? localStorage.access_token : '',
  isAuthenticated: localStorage.isLoggedIn ? localStorage.isLoggedIn : false,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      console.log("action.payload", action.payload)
      state.isAuthenticated = action.payload.isAuthenticated
      state.token = action.payload.token
    },
  },
})

export const { setAuth } = authSlice.actions

export default authSlice.reducer